<script setup>  
    import { inject } from 'vue';
    import Overview from '@/components/result/ai-literacy-2026/Overview.vue';
    
    // props로 받는 데이터 (3반씩 그룹화된 classData)
    const props = defineProps({
        classData: {
            type: Array,
            default: () => []
        },
        pageIndex: {
            type: Number,
            default: 0
        }
    });
    
    // 부모 컴포넌트에서 전달받은 전체 데이터
    const principalData = inject('principalData');
    const schoolData = inject('schoolData');
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap"> 
           <Overview 
                view-type="class" 
                :classData="classData"
                :principalData="principalData"
                :schoolData="schoolData"
                :pageIndex="pageIndex"
            />
        </div>
    </div>
</template>